/* tslint:disable */
/* eslint-disable */
/**
 * Client
 * Placeholder description of the order & payment instruction service. Detailed description to be provided by Monavate team.
 *
 * The version of the OpenAPI document: $project.version
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ClientApiKey } from '../models';
// @ts-ignore
import type { ClientApiKeyCreateResponse } from '../models';
// @ts-ignore
import type { ClientApiKeyRequest } from '../models';
// @ts-ignore
import type { NotFoundError } from '../models';
// @ts-ignore
import type { ValidationError } from '../models';
/**
 * ClientAPIKeyApi - axios parameter creator
 * @export
 */
export const ClientAPIKeyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new unique authorization key.
         * @summary Create Key
         * @param {ClientApiKeyRequest} [clientApiKeyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientApiKey: async (clientApiKeyRequest?: ClientApiKeyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api-keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientApiKeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes one unique authorization key.
         * @summary Delete Key
         * @param {string} apiKeyId The ID of a unique authorization key of a particular client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClientApiKey: async (apiKeyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('deleteClientApiKey', 'apiKeyId', apiKeyId)
            const localVarPath = `/api-keys/{api-key-id}`
                .replace(`{${"api-key-id"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of unique authorization keys.
         * @summary Get Key Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClientApiKeys: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api-keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientAPIKeyApi - functional programming interface
 * @export
 */
export const ClientAPIKeyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientAPIKeyApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new unique authorization key.
         * @summary Create Key
         * @param {ClientApiKeyRequest} [clientApiKeyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClientApiKey(clientApiKeyRequest?: ClientApiKeyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientApiKeyCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClientApiKey(clientApiKeyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAPIKeyApi.createClientApiKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes one unique authorization key.
         * @summary Delete Key
         * @param {string} apiKeyId The ID of a unique authorization key of a particular client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteClientApiKey(apiKeyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteClientApiKey(apiKeyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAPIKeyApi.deleteClientApiKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of unique authorization keys.
         * @summary Get Key Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listClientApiKeys(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientApiKey>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listClientApiKeys(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAPIKeyApi.listClientApiKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientAPIKeyApi - factory interface
 * @export
 */
export const ClientAPIKeyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientAPIKeyApiFp(configuration)
    return {
        /**
         * Creates a new unique authorization key.
         * @summary Create Key
         * @param {ClientAPIKeyApiCreateClientApiKeyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientApiKey(requestParameters: ClientAPIKeyApiCreateClientApiKeyRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientApiKeyCreateResponse> {
            return localVarFp.createClientApiKey(requestParameters.clientApiKeyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes one unique authorization key.
         * @summary Delete Key
         * @param {ClientAPIKeyApiDeleteClientApiKeyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClientApiKey(requestParameters: ClientAPIKeyApiDeleteClientApiKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteClientApiKey(requestParameters.apiKeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of unique authorization keys.
         * @summary Get Key Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClientApiKeys(options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientApiKey>> {
            return localVarFp.listClientApiKeys(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createClientApiKey operation in ClientAPIKeyApi.
 * @export
 * @interface ClientAPIKeyApiCreateClientApiKeyRequest
 */
export interface ClientAPIKeyApiCreateClientApiKeyRequest {
    /**
     * 
     * @type {ClientApiKeyRequest}
     * @memberof ClientAPIKeyApiCreateClientApiKey
     */
    readonly clientApiKeyRequest?: ClientApiKeyRequest
}

/**
 * Request parameters for deleteClientApiKey operation in ClientAPIKeyApi.
 * @export
 * @interface ClientAPIKeyApiDeleteClientApiKeyRequest
 */
export interface ClientAPIKeyApiDeleteClientApiKeyRequest {
    /**
     * The ID of a unique authorization key of a particular client.
     * @type {string}
     * @memberof ClientAPIKeyApiDeleteClientApiKey
     */
    readonly apiKeyId: string
}

/**
 * ClientAPIKeyApi - object-oriented interface
 * @export
 * @class ClientAPIKeyApi
 * @extends {BaseAPI}
 */
export class ClientAPIKeyApi extends BaseAPI {
    /**
     * Creates a new unique authorization key.
     * @summary Create Key
     * @param {ClientAPIKeyApiCreateClientApiKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAPIKeyApi
     */
    public createClientApiKey(requestParameters: ClientAPIKeyApiCreateClientApiKeyRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientAPIKeyApiFp(this.configuration).createClientApiKey(requestParameters.clientApiKeyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes one unique authorization key.
     * @summary Delete Key
     * @param {ClientAPIKeyApiDeleteClientApiKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAPIKeyApi
     */
    public deleteClientApiKey(requestParameters: ClientAPIKeyApiDeleteClientApiKeyRequest, options?: RawAxiosRequestConfig) {
        return ClientAPIKeyApiFp(this.configuration).deleteClientApiKey(requestParameters.apiKeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of unique authorization keys.
     * @summary Get Key Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAPIKeyApi
     */
    public listClientApiKeys(options?: RawAxiosRequestConfig) {
        return ClientAPIKeyApiFp(this.configuration).listClientApiKeys(options).then((request) => request(this.axios, this.basePath));
    }
}

